const heros = [
    { id: 1,image:"products.svg", title: "Best Products",desc:" Variety of products in various industries with high quality"},
    { id: 2,image:"shipping.svg", title: "Shipping Methods" ,desc:"Quick and simple shipping from Egypt to Anywhere" },
    { id: 3,image:"security.svg", title: "Payment Security" ,desc:"Shop With Confidence: Secure Payments Guaranteed"},
    { id: 4,image:"support.svg", title: "Support 24/7" ,desc:"24/7 Online support For A Best Shopping Experience!" },
];

export default heros;
